import React, { useReducer } from 'react'
import SchedulePickupContext from './schedulePickupContext'
import SchedulePickupReducer from './schedulePickupReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import { CLEAR_RESPONSE, RESPONSE_STATUS, GET_SCHEDULE_DATA } from './schedulePickupTypes'

const SchedulePickupState = (props) => {
    const initialState = {
        responseStatus: null,
        schedule_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
    }

    const [state, dispatch] = useReducer(SchedulePickupReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const addSchedulePickup = async (formData, fromVariable) => {
        const from = fromVariable ? fromVariable : 'addPickup'
        try {
            const [res] = await Promise.all([
                apiCall('post', 'addSchedulePickupTiming', formData, '', 'schedulepickup'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const getSchedulePickupTiming = async (formData, fromVariable) => {
        const from = fromVariable ? fromVariable : 'getSchedulePickupTiming'
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getSchedulePickupTiming', formData, '', 'schedulepickup'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SCHEDULE_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <SchedulePickupContext.Provider
            value={{
                responseStatus: state.responseStatus,
                schedule_data: state.schedule_data,
                addSchedulePickup,
                getSchedulePickupTiming,
                clearResponse,
            }}
        >
            {props.children}
        </SchedulePickupContext.Provider>
    )
}

export default SchedulePickupState
